import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { combineLatest, filter, map, Observable, of } from 'rxjs';

import { Amount } from '@fcom/dapi';
import { ExtendedFareFamily } from '@fcom/common-booking/interfaces';

@Component({
  selector: 'fin-multi-city-fare-family-selector',
  styleUrls: ['./multi-city-fare-family-selector.component.scss'],
  templateUrl: './multi-city-fare-family-selector.component.html',
})
export class MultiCityFareFamilySelectorComponent implements OnInit {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input({ required: true }) fareFamily$: Observable<ExtendedFareFamily>;
  @Input({ required: true }) currencyCode: string;
  @Input({ required: true }) basePrice$: Observable<string>;
  @Input() selectedFareFamily$: Observable<ExtendedFareFamily> = of(null);

  @Output() selectFareFamily: EventEmitter<boolean> = new EventEmitter<boolean>();

  priceDifference$: Observable<Amount>;
  defaultPrice$: Observable<Amount>;
  isChecked$: Observable<boolean>;

  ngOnInit(): void {
    this.defaultPrice$ = this.fareFamily$.pipe(
      map((fareFamily) => ({ amount: fareFamily.totalPrice, currencyCode: this.currencyCode }))
    );

    this.isChecked$ = combineLatest([this.fareFamily$, this.selectedFareFamily$]).pipe(
      map(([fareFamily, selectedFareFamily]) => fareFamily?.fareFamilyCode === selectedFareFamily?.fareFamilyCode)
    );

    this.priceDifference$ = combineLatest([this.fareFamily$, this.basePrice$]).pipe(
      filter(([fareFamily, basePrice]) => Boolean(fareFamily && basePrice)),
      map(([fareFamily, basePrice]) => ({
        amount: String(Number(fareFamily.totalPrice) - Number(basePrice)),
        currencyCode: this.currencyCode,
      }))
    );
  }

  checkboxChange(): void {
    this.selectFareFamily.emit();
  }
}
